import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Music2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import api, { API } from "@/lib/api";

export default function SongsTab() {
  const { t } = useI18n();
  const [songs, setSongs] = useState([]);

  useEffect(() => {
    api.get("/orders?status=completed").then(({ data }) => setSongs(data));
  }, []);

  const fileUrl = (path) => {
    const token = localStorage.getItem("ams_token");
    return `${API}/files/${path}?auth=${token}`;
  };

  if (songs.length === 0) {
    return <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">{t("dashboard.noOrders")}</div>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {songs.map((s) => (
        <Link key={s.order_id} to={`/orders/${s.order_id}`} className="overflow-hidden rounded-2xl border border-border bg-card transition-transform hover:-translate-y-1">
          <div className="flex h-40 items-center justify-center bg-muted">
            {s.generated?.thumbnail_storage_path ? (
              <img src={fileUrl(s.generated.thumbnail_storage_path)} alt={s.generated.title} className="h-full w-full object-cover" />
            ) : (
              <Music2 className="h-10 w-10 text-muted-foreground/40" />
            )}
          </div>
          <div className="p-4">
            <p className="truncate font-medium">{s.generated?.title}</p>
            <p className="text-xs text-muted-foreground">{t(`options.style_${s.form.style}`)} · {s.form.duration_minutes} min</p>
          </div>
        </Link>
      ))}
    </div>
  );
}
